<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-skeleton-loader v-if="$store.state.payments.retrieveLoader" transition="fade-transition" type="card" />
      <v-card min-width="350" v-else>
        <v-card-title class="py-4 text-center" v-if="payment.account.logo">
          <v-spacer />
          <v-sheet rounded outlined>
            <v-responsive class="align-center" :aspect-ratio="1/1">
              <v-sheet class="px-1" width="100">
                <v-img :src="payment.account.logo" width="100%" />
              </v-sheet>
            </v-responsive>
          </v-sheet>
          <v-spacer />
        </v-card-title>
        <v-card-subtitle class="py-4">
          <v-row>
            <v-col class="text-center" cols="12">
              <span class="d-block body-1 text--secondary font-weight-medium">{{payment.description}}</span>
              <span class="d-block body-2 text--secondary font-weight-medium">{{payment.account.name}} <template v-if="payment.customer">para {{payment.customer.name}}</template></span>
              <span class="d-block text-h6 text--secondary font-weight-medium" v-if="payment.status !== 'succeeded'">{{payment.amount | currency(payment.currency)}} {{payment.currency}}  del {{payment.date | date}}</span>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="px-0 background">
          <v-row class="px-4" no-gutters>
            <v-col class="pt-3 text-center">
              <v-icon color="red" large>mdi-alert</v-icon>
              <span class="d-block mt-2 text-h6 red--text font-weight-medium">Tu intento de pago ha fallado</span>
              <span class="d-block">Verifica los datos de tu método de pago y vuelve a intentarlo</span>
              <v-btn class="mt-8" @click="$router.push({ name: 'PaymentRetrieve', params: { id: payment.id } })" :color="payment.account.color_background" dark height="40" block>Volver a intentarlo</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <piriod-sign />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSign from '@/components/PiriodSign'
export default {
  components: {
    PiriodSign
  },
  mixins: [
    GenericViewMixin
  ],
  computed: mapState({
    payment: state => state.payments.payDetail
  }),
  created () {
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'pay',
      id: this.$route.params.id
    })
    .catch((error) => {
      if (error.response.status === 404) {
        this.$router.push({ name: 'PageNotFound' })
      }
    })
  }
}
</script>